import React, { useEffect, useState } from "react";
import FieldsRenderer from "../components/UI Helpers/InputFieldsRendererCommon/InputFieldsRendererComponent";
import { showAlertMessage } from "../components/MasterComponents/CommonFunctionalities";
import { validateForm } from "../components/UI Helpers/HelperFunctions/Helper"; 
import CommonCalls from "../components/CommonAPICalls/CommonCalls"; 
import Loader from "../components/UI Helpers/Simple Loading/Loader";

const apiCall = new CommonCalls();

function MetalPriceSetter() {
   const [saveBtn, setSaveBtn] = useState(false);
        const [loading, setLoading] = useState(true);
        const [formInputData, setFormInputData] = useState("");
    
        const inputsFieldAr = [
          {
              name: 'price_gram_18k',
              id: 'price_gram_18k',
              label: 'Price of Gold (18K)',
              className: "col-lg-6",
              inputType: "number",
          },
          {
              name: 'price_gram_20k',
              id: 'price_gram_20k',
              label: 'Price of Gold (20K)',
              className: "col-lg-6",
              inputType: "number",
          },
          {
              name: 'price_gram_21k',
              id: 'price_gram_21k',
              label: 'Price of Gold (21K)',
              className: "col-lg-6",
              inputType: "number",
          },
          {
              name: 'price_gram_22k',
              id: 'price_gram_22k',
              label: 'Price of Gold (22K)',
              className: "col-lg-6",
              inputType: "number",
          },
          {
              name: 'price_gram_24k',
              id: 'price_gram_24k',
              label: 'Price of Gold (24K)',
              className: "col-lg-6",
              inputType: "number",
          },
          {
              name: 'price_per_10_grams',
              id: 'price_per_10_grams',
              label: 'Price of Silver (10g)',
              className: "col-lg-6",
              inputType: "number",
          },
        
      ];
  
      const GetZakkatPriceData = async ()=>{
          const response = await apiCall.getZakkatPrice();
          if (response?.status === 200) {
              setFormInputData(
              response?.data[0]
          )
              setLoading(false);
              return response;
          } else {
              setLoading(false);
              showAlertMessage("Could not Load, Please Reload the Page", "fail");
              return;
          }
      }
  
        useEffect(()=>{
          setLoading(true)
          GetZakkatPriceData()
        },[])
  
       
       const updateZakkatData = async () => {
      setSaveBtn(true);
  
      let validationResponse = validateForm(inputsFieldAr, formInputData);
      if (!validationResponse) {
          setSaveBtn(false);
          return;
      }
  
      const parsedData = Object.fromEntries(
          Object.entries(formInputData).map(([key, value]) => [key, parseInt(value) || 0])
      );
  
      setFormInputData(parsedData);
  
      const response = await apiCall.updateZakkatPrice(parsedData);
  
      if (response?.status === 202) {
          setSaveBtn(false);
          GetZakkatPriceData()
          showAlertMessage(response?.message, "success");
          return response;
      } else {
          setSaveBtn(false);
          showAlertMessage(response?.message, "fail");
          return;
      }
  };
  
        return (
            <>
                 <div className="user-detail-view-container container-fluid ps-4 pe-4 py-4">
                   {
                      loading ?
                      <div className='mt-5'> <Loader /> </div>
                      :
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                setSaveBtn(true);
                                updateZakkatData();
                            }}
                        >
                            <div className="w-100 text-end ">
                                <button
                                    type="submit"
                                    className="connect-button w-fit p-3 py-2"
                                    disabled={saveBtn}
                                >
                                    <div>
                                        <span> Save </span>{" "}
                                        {saveBtn ? (
                                            <output
                                                className="spinner-border spinner-border-sm ms-1"
                                                aria-hidden="true"
                                            ></output>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                </button>
                            </div>
                           
                            <FieldsRenderer
                                fieldsArray={inputsFieldAr}
                                updateState={setFormInputData}
                                currentState={formInputData}
                            />
                        </form>
  
                   }
                    </div>
            </>
        );
}

export default MetalPriceSetter